<template>
    <div
        class="md-banner layout1"
        :class="type === 'color' ? 'mg-bg' : ''"
        :style="{ marginBottom, ...colorStyle, '--background-attachment': backgroundAttachment }"
    >
        <banner
            ref="banner"
            :class="{
                'mg-container': !fullColumn,
                'mobile-no-margin': mobileNoMargin
            }"
            :type="type"
            :mobileType="mobileType"
            :sizeOption="sizeOption"
            :pictureOption="pictureOption"
            :pictureListOption="pictureListOption"
            :rawDot="true"
            :maskOption="maskOption"
        >
            <div class="f-col" :class="align">
                <div class="banner-content" v-animated="{name: 'fade-in', duration: 1500, enable: showAnimationEffects}">
                    <site-title
                        :title="title"
                        :align="align"
                    />
                    <site-sub-title
                        :title="subTitle"
                        :size="16"
                        :mbSize="16"
                        :align="align"
                    />
                </div>
            </div>
        </banner>
    </div>
</template>

<script>
import common from '../index-layout';
export default {
    mixins: [common],
    data() {
        return {
            backgroundAttachmentFixed: true
        }
    },
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-banner.layout1 {
    .banner {
        .default-bg {
            background: rgba(25, 25, 25, 1);
        }
        .f-col {
            display: flex;
            &.left {
                justify-content: flex-start;
            }
            &.center {
                justify-content: center;
            }
            &.right {
                justify-content: flex-end;
            }
        }
        .banner-content {
            z-index: calc(var(--level-sublow) + 1);
            display: flex;
            flex-direction: column;
            .site-title:not(:last-child) {
                margin-bottom: 25px;
            }
            @include media-600 {
                .site-title:not(:last-child) {
                    margin-bottom: 15px;
                }
            }
        }

        .swiper-pagination-bullet {
            background-color: #ffffff;
            opacity: 0.5;
            @include media-1080 {
                width: 6px;
                height: 6px;
            }
            @include media-600 {
                width: 4px;
                height: 4px;
            }
        }
        .swiper-pagination-bullet-active {
            opacity: 1;
        }
        .single-picture {
            background-attachment: var(--background-attachment);
            @include media-600 {
                background-attachment: unset;
            }
        }
    }
}
</style>
